// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1HKMo","containerItemsCenter":"Skeleton_containerItemsCenter__30xZx"};